import * as types from './mutation-types';

export default {
  [types.SET_FORMS](state, forms) {
    state.forms = forms;
  },
  [types.SET_ERRORS](state, errors) {
    state.errors = errors;
  }
};
